module.exports = __webpack_public_path__ + "img/theme-two.771dd347.png";